import { CreateRequestDto, EducationalProgram, EducationalProgramClient, Request, RequestClient } from './../../../../services/apis/web-api-client';
import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { skip } from 'rxjs/operators';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss'],
})
export class ModalComponent implements OnInit {
  public programId: string | undefined = undefined;
  programs: EducationalProgram[] = [];
  selectedProgram: EducationalProgram[] = [];
  modalRef!: BsModalRef;
  isLoading: boolean = true;
  dropdownCOLSettings = {
    tagToBody: false,
    autoPosition: false,
    singleSelection: true,
    text: "Выберите курс",
    selectAllText: 'Выбрать все',
    unSelectAllText: 'Снять выбранные',
    enableSearchFilter: true,
    classes: "myclass custom-class",
    searchPlaceholderText: "Поиск",
  };;


  request: CreateRequestDto = new CreateRequestDto({ educationalProgramId: null, paymentValue: "0,00" });

  constructor(
    public bsModalRef: BsModalRef,
    private educationalProgramClient: EducationalProgramClient,
    private requestClient: RequestClient,
    private toastrService: ToastrService,
  ) {
    this.modalRef = bsModalRef!;
  }

  ngOnInit() {

    this.educationalProgramClient.getAll().subscribe((response) => {
      this.programs = response;
      console.log('this.programId', this.programId)
      if (this.programId !== undefined) {
        this.selectedProgram.push(response.find(x => x.id == this.programId))
        this.updateSelectedCOL();
      };
      this.isLoading = false;
    })

  }

  SendMessage() {
    if (
      this.selectedProgram.length < 1
    ) {
      this.toastrService.warning('Выберете образовательный курс!', 'Внимание');
      return;
    }
    if( this.request.email === undefined || this.request.email === null ||  this.request.email.length < 1){
      console.log
      this.toastrService.warning('Заполните электронный адрес!', 'Внимание');
      return;
    }
    if(this.request.phone ===undefined || this.request.phone ===null || this.request.phone.length !== 10){
      this.toastrService.warning('Заполните номер телефона!', 'Внимание');
      return;
    }
    this.request.paymentValue = this.selectedProgram[0].price;
    this.requestClient.create(this.request).subscribe((response) => {
      this.toastrService.success('Ваша заявка отправлена!', 'Успех');
      this.modalRef.hide();
    })
  }

  onCOLSelect(item: EducationalProgram[]) {
    this.updateSelectedCOL();
  }

  OnCOLDeSelect(item: any) {
    this.updateSelectedCOL();
  }
  onSelectAllCities(items: any) {
    this.updateSelectedCOL();
  }

  onDeSelectAllCities(items: any) {
    this.updateSelectedCOL();
  }

  updateSelectedCOL() {
    this.request.educationalProgramId = this.selectedProgram.length > 0 ? this.selectedProgram[0].id : undefined;
  }


}
